import { render, staticRenderFns } from "./CascadeMatterChecker.vue?vue&type=template&id=b9dd3eb0&scoped=true&"
import script from "./CascadeMatterChecker.vue?vue&type=script&lang=js&"
export * from "./CascadeMatterChecker.vue?vue&type=script&lang=js&"
import style0 from "./CascadeMatterChecker.vue?vue&type=style&index=0&id=b9dd3eb0&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b9dd3eb0",
  null
  
)

export default component.exports